import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import BB from './images/BB.png';
import { faAngleDown, faAngleUp, faAngleRight, faArrowLeft, faArrowRight, faClock, faLocation, faLocationDot, faLocationPin, faTimesCircle, faInfoCircle, faPhone, faPhoneFlip, faStarAndCrescent, faStarHalf, faHandSparkles, faCircleInfo,faWallet, faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BuildCoin from './images/buildcoin.png';
import Box from './images/box.png';
import Store from './images/store.png';
import Sparkle from './images/sparkle.png';
import Wallet from './images/wallet.png';
import Check from './images/check.png';
import Header from './Component/Header';
import Walleticon from './images/Walleticon.png';
import ProjectHeader from './Component/ProjectHeader';
import WindowListPopup from './Component/WindowCountPopup';


function Proceed() {
  const navigate = useNavigate();
  const location = useLocation();
  const quotationId = location?.state?.quotationId
  // console.log(quotationId)
  const type = location?.state?.type
  const [data, setData] = useState({});
  const [selectedItem, setSelectedItem] = useState(null);
  const [showQuoteSummary, setShowQuoteSummary] = useState(false);
  const [buildCoinsEnabled, setBuildCoinsEnabled] = useState(false);
  const [showCallbackPopup, setShowCallbackPopup] = useState(false);
const [callbackName, setCallbackName] = useState('');
const [selectedTab, setSelectedTab] = useState('today');
const [selectedTimeSlot, setSelectedTimeSlot] = useState('now');
const [callbackDescription, setCallbackDescription] = useState('');
const [showBuildCoinsInfo, setShowBuildCoinsInfo] = useState(false);
const [showOrderReceivedPopup, setShowOrderReceivedPopup] = useState(false);
const [walletCoinsApplicable,setWalletCoinsApplicable] = useState(0)
const [walletCoinsApplied, setWalletCoinsApplied] = useState(false);
const [walletBalance, setWalletBalance] = useState(0);
const [coinLedger,setCoinLedger] = useState({});
console.log("walletBalance:",walletBalance)
const [showWindowListPopup, setShowWindowListPopup] = useState(false);
const [selectedWindowItem, setSelectedWindowItem] = useState(null);

  useEffect(() => {
      fetchQuotationDetails();
      getBuildcoinsWallet();
  }, [quotationId]);

    const fetchQuotationDetails = async () => {
      const token = sessionStorage.getItem('token');
      try {
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-quote?quotation_id=${quotationId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
               
        const data = await response.json();
        console.log(data)
        //console.log(data.data.quotation);
        setData(data.data.quotation);
        //console.log(sampleData)
      } catch (err) {
        console.error('Error fetching quotation details:', err);
      }
    };
    
    const toggleQuoteSummary = () => {
      setShowQuoteSummary(!showQuoteSummary);
    };

    
    const toggleWalletCoins = () => {
      const newWalletCoinsState = !walletCoinsApplied;
      setWalletCoinsApplied(newWalletCoinsState);
      
      // Create a copy of the data object to avoid direct state mutation
      const updatedData = { ...data };
      
      if (newWalletCoinsState) {
        // Apply wallet BuildCoins discount (subtract 8,000)
        updatedData.total = (updatedData.total || 0) - 0;
        // Update wallet balance
        setWalletBalance(newWalletCoinsState - 0); // 10000 - 8000 = 2000
      } else {
        // Remove wallet BuildCoins discount (add 8,000 back)
        updatedData.total = (updatedData.total || 0) + 0;
        // Restore wallet balance
        setWalletBalance(0);
      }
      
      // Update the data state with the modified total
      setData(updatedData);
    };

    const handlePlaceOrder = async () => {
      try {
        const token = sessionStorage.getItem('token');
        // You might want to make an API call to place the order
        // For now, we'll just show the popup
        setShowOrderReceivedPopup(true);
        
        // Optional: You could add a timeout to automatically close the popup after a few seconds
        // setTimeout(() => setShowOrderReceivedPopup(false), 5000);
      } catch (err) {
        console.error('Error placing order:', err);
      }
    };

    const toggleBuildCoins = () => {
      const newBuildCoinsState = !buildCoinsEnabled;
      setBuildCoinsEnabled(newBuildCoinsState);
      
      // Create a copy of the data object to avoid direct state mutation
      const updatedData = { ...data };
      
      if (newBuildCoinsState) {
        // Apply BuildCoins discount (subtract 40,000)
        updatedData.total = (updatedData.total || 0) - 40000;
        // Add a buildCoinsDiscount property to track the discount amount
        updatedData.buildCoinsDiscount = 40000;
      } else {
        // Remove BuildCoins discount (add 40,000 back)
        updatedData.total = (updatedData.total || 0) + 40000;
        // Remove the buildCoinsDiscount property
        updatedData.buildCoinsDiscount = 0;
      }
      
      // Update the data state with the modified total
      setData(updatedData);
    };
    
/*     const applyBuildcoinsForOrder = async () => {
      const token = sessionStorage.getItem('token');
      try {
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}quotations/apply-buildcoins-for-order`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          },
          body: JSON.stringify(),
        });
               
        const data = await response.json();
        console.log(data)
      } catch (err) {
        console.error('Error applying buildcoins:', err);
      }
    };  */
    
    //const [buildCoinsEnabled, setBuildCoinsEnabled] = useState(false);

const applyBuildcoinsForOrder = async (buildcoins,type) => {
  const token = sessionStorage.getItem('token');
  console.log(buildcoins)
console.log("type:",type)
  let requestdata;
  if (type.toLowerCase() === "wallet"){
    requestdata = {consumer_id:buildcoins.consumer_id,
      partner_id:buildcoins.partner_id,
      order_id:data._id,
      coinledger_id:buildcoins._id,
      type}
  }else{
  requestdata = {consumer_id:buildcoins.consumer_id,
    partner_id:buildcoins.partner_id,
    order_id:buildcoins.order_id,
    reservation_id:buildcoins._id,
    type}
  }


  console.log("request body:",requestdata)

  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/apply-buildcoins-for-order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(requestdata), 
    });

    const data = await response.json();
    if (response.ok) {
      if(type.toLowerCase() === 'wallet'){
        setWalletCoinsApplied(true)
      }else{
        setBuildCoinsEnabled(true);
      }
      console.log('BuildCoins applied:', data);
    } else {
      console.error('Failed to apply BuildCoins:', data);
    }
  } catch (err) {
    console.error('Error applying buildcoins:', err);
  }
};

const removeBuildcoinsForOrder = async (buildcoins,type) => {
  const token = sessionStorage.getItem('token');

  console.log("type:",type)
  let requestdata;
  if (type.toLowerCase() === "wallet"){
    requestdata = {consumer_id:buildcoins.consumer_id,
      partner_id:buildcoins.partner_id,
      //order_id:buildcoins.order_id,
      coinledger_id:buildcoins._id,
      type}
  }else{
  requestdata = {consumer_id:buildcoins.consumer_id,
    partner_id:buildcoins.partner_id,
    order_id:buildcoins.order_id,
    reservation_id:buildcoins._id,
    type}
  }

  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/remove-applied-buildcoins-for-order`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      },
      body: JSON.stringify(requestdata),
    });

    const data = await response.json();
    if (response.ok) {
      if(type.toLowerCase() === 'wallet'){
        setWalletCoinsApplied(false)
      }else{
        setBuildCoinsEnabled(false);
      }      console.log('BuildCoins removed:', data);
    } else {
      console.error('Failed to remove BuildCoins:', data);
    }
  } catch (err) {
    console.error('Error removing buildcoins:', err);
  }
};


    const getBuildcoinsWallet = async () => {
      const token = sessionStorage.getItem('token');
      const customer = JSON.parse(localStorage.getItem('userData'));
      console.log(customer)
      const customerId = customer._id
      console.log(customerId)
      try {
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}customer/quotations/get-buildcoins-wallet?customer_id=${customerId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-token': token
          }
        });
               
        const data = await response.json();
        console.log(data)
        setWalletBalance(data?.wallet?.available_coins)
        setWalletCoinsApplicable(data?.availableCoinLedgers[0]?.build_coins)
        setCoinLedger(data?.availableCoinLedgers[0]);
      } catch (err) {
        console.error('Error getting buildcoins wallet:', err);
      }
    }; 
    
 const applyBuildCoinsFromWallet = async (coinLedger, orderId) => {
  const coinledgerId = coinLedger._id;
  try {
    const response = await fetch(`${process.env.REACT_APP_FORE_BUILDCOINS}rewards/apply-buildcoins-from-wallet`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // Add authorization header if needed
        // 'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        coinledger_id: coinledgerId,
        order_id: orderId
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to apply buildcoins');
    }

    return data;
  } catch (error) {
    console.error('Error applying buildcoins:', error);
    throw error;
  }
};   
      
return(
  <div className="flex flex-col">
  <Header />
  <ProjectHeader
  type={'Review & Place Order'}
  categoryName={data?.product_category_id?.product_category_name}
  Name={data?.project_id?.projectName}
  buildcoins={
      data?.buildcoins && Array.isArray(data.buildcoins)
        ? data.buildcoins.reduce((sum, item) => sum + (item?.reserved_coins ?? 0), 0)
        : 0
    }  
  />

{/*   <div className="pb-2 pt-2 flex items-center space-x-4 border-b border-gray-200 mb-2 z-50 mt-1 p-2">

    <button onClick={() => navigate(-1)}
    className="p-2 hover:bg-gray-100 rounded-full">
      <FontAwesomeIcon icon={faArrowLeft} className="text-gray-600 w-4 h-4" />
    </button>

    <div className='flex justify-between w-full'>
    <div className="flex flex-col">
      <span className="text-base font-semibold text-gray-900 capitalize">
        {data?.project_id?.projectName?.toUpperCase()}
      </span>
      <span className="text-sm text-gray-500">
        {data?.product_category_id?.product_category_name}
      </span>
    </div>
    <div onClick={() => setShowBuildCoinsInfo(true)} className="cursor-pointer">
      <div className='mt-0.5 flex flex-row'>
        <p className='mt-0.5 text-xs'>50,000</p>
        <img src={BuildCoin} alt="BuildCoin" className="h-5 w-6 ml-1" />
      </div>
      <div className='text-xs font-bold'>BuildCoins</div>
      <div className='border-b border-dotted border-[#A8A1A1] text-xs text-[#A8A1A1]'>What's this?</div>
      
      </div>
    </div>
  </div> */}

  
{/* Quote Summary Section */}
<div className="mt-1 bg-white p-4">
  {/* Removed the toggle button and always show the content */}
  <div className="w-full flex justify-between items-center text-lg font-semibold text-[#3E1EDD] mb-3">
    <span className="text-md font-semibold border-b border-dotted border-[#3E1EDD]"> View Quote Summary</span>
  </div>
 <div className="border border-[#E0D9D9] p-3">
  <h1 className='font-semibold border-b border-gray-300 pb-1'>{data.quotation_number}</h1>
  <div className="space-y-2 mt-2">
    {data?.items?.map((item, index) => (
      <div key={index} className="mb-3">
        {/* Different display for Windows vs Tiles */}
        {data?.product_category_id?.product_category_name?.toLowerCase() === 'windows' ? (
          // Windows specific layout
          <div className="pt-1">
            <div className="flex justify-between items-center">
              <p className="text-md font-medium ml-1">{item.item_name}</p>
              <p className="text-sm">{item.areaInSft} sq.ft</p>
            </div>
            
            {/* Display application area name (like Sliding, French) */}
            <div className="mt-1.5 pl-1">
              <div className="flex justify-between items-center">
                <p className="text-md font-bold text-red-500 ">
                  {item.application_areas?.area_name || item.product_subcategory?.name || "Windows"}
                </p>
                <p className="text-sm font-regular text-gray-600">₹{item.selling_price.toLocaleString()}/sq.ft</p>
              </div>
              <div className="flex justify-between items-center mt-1">
                <p
                  className="text-sm text-blue-600 font-medium cursor-pointer hover:underline"
                  onClick={() => {
                    setSelectedWindowItem(item);
                    setShowWindowListPopup(true);
                  }}
                >
                  {item.application_areas?.count} Windows
                </p>
                <p className="text-md font-medium">
                  ₹{Number(item.total || (item.selling_price * item.quantity)).toLocaleString('en-IN')}
                </p>
              </div>
            </div>
          </div>
        ) : (
          // Original Tiles layout
          <div className="pt-1 flex justify-between">
            <div className="flex-1 space-y-2">
              {/* Product Information Section */}
              <div className="space-y-0.5">
                {data?.product_category_id?.product_category_name?.toLowerCase() === 'doors' ? (
                 <>
                <p className="text-sm font-medium text-gray-800 line-clamp-1">{item.item_group_name}</p>
                {item.item_name === item.item_group_name ? (
                  <p className="text-sm text-gray-500 line-clamp-1 italic">No design selected</p>
                ) : (
                  <p className="text-sm text-gray-700 line-clamp-1">{item.item_name}</p>
                )}
              </>

                ) : (
                  <p className="text-sm font-medium text-gray-800 line-clamp-2">{item.item_name}</p>
                )}
              </div>

              {/* Application Areas Section */}
              {data?.product_category_id?.product_category_name?.toLowerCase() === 'doors' ? (
                <div className="mt-1 flex items-baseline space-x-2">
                  <span className="px-2 py-0.5 bg-gray-100 rounded-md text-xs font-medium text-[#3E1EDD]">
                    {item.application_areas.area_name}
                  </span>
                  <span className="text-xs font-medium text-gray-500">
                    {item.application_areas.count} {item.application_areas.count === 1 ? 'Door' : 'Doors'}
                  </span>
                </div>
              ) : (
                <>
                  {item.applied_areas && item.applied_areas.length > 0 && (
                    <div className="mt-1">
                      {(() => {
                        // Group areas by design name
                        const designGroups = {};
                        const areasWithoutDesign = [];
                        
                        // Process each applied area
                        item.applied_areas.forEach(area => {
                          if (area.selected_design?.design_name) {
                            // If area has a design, add to design groups
                            if (!designGroups[area.selected_design.design_name]) {
                              designGroups[area.selected_design.design_name] = [];
                            }
                            designGroups[area.selected_design.design_name].push(area);
                          } else {
                            // If area has no design, add to separate array
                            areasWithoutDesign.push(area);
                          }
                        });
                        
                        // Create result array to hold all rendered elements
                        const result = [];
                        
                        // Render each design group
                        Object.entries(designGroups).forEach(([designName, areas], designIdx) => {
                          result.push(
                            <div key={`design-${designIdx}`} className="mb-2">
                              <p className="text-sm text-gray-700">{designName}</p>
                              
                              {/* Applied Areas button for this specific design */}
                              <button
                                className="mt-0.5 text-xs text-[#3E1EDD]"
                                onClick={() => {
                                  // Toggle display of applied areas for this specific design
                                  const designKey = `design-${index}-${designIdx}`;
                                  setSelectedItem(selectedItem === designKey ? null : designKey);
                                }}
                              >
                                Applied Areas
                                <FontAwesomeIcon
                                  icon={selectedItem === `design-${index}-${designIdx}` ? faAngleUp : faAngleDown}
                                  className="ml-2 w-3 h-3"
                                />
                              </button>
                              
                              {/* Show applied areas for this design when expanded */}
                              {selectedItem === `design-${index}-${designIdx}` && (
                                <div className="mt-1 pl-2 border-l-2 border-gray-200">
                                  {areas.map((area, areaIdx) => (
                                    <div key={areaIdx} className="mb-1">
                                      <p className="text-xs text-gray-500">
                                        • {area.area_name || area.room_name}
                                      </p>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        });
                        
                        // Add areas without design if they exist
                        if (areasWithoutDesign.length > 0) {
                          result.push(
                            <div key="no-design" className="mb-2">
                              <p className="text-xs text-gray-500">Design not selected</p>
                              
                              {/* Applied Areas button for areas without design */}
                              <button
                                className="mt-0.5 text-xs text-[#3E1EDD]"
                                onClick={() => {
                                  // Toggle display of areas without design
                                  const noDesignKey = `no-design-${index}`;
                                  setSelectedItem(selectedItem === noDesignKey ? null : noDesignKey);
                                }}
                              >
                                Applied Areas
                                <FontAwesomeIcon
                                  icon={selectedItem === `no-design-${index}` ? faAngleUp : faAngleDown}
                                  className="ml-2 w-3 h-3"
                                />
                              </button>
                              
                              {/* Show areas without design when expanded */}
                              {selectedItem === `no-design-${index}` && (
                                <div className="mt-1 pl-2 border-l-2 border-gray-200">
                                  {areasWithoutDesign.map((area, areaIdx) => (
                                    <div key={areaIdx} className="mb-1">
                                      <p className="text-xs text-gray-500">
                                        • {area.area_name || area.room_name}
                                      </p>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        }
                        
                        // If no design groups and no areas without design, show all areas directly
                        if (Object.keys(designGroups).length === 0 && areasWithoutDesign.length === 0) {
                          result.push(
                            <div key="all-areas" className="mb-2">
                              <button
                                className="mt-0.5 text-xs text-[#3E1EDD]"
                                onClick={() => {
                                  // Toggle display of all areas
                                  const allAreasKey = `all-areas-${index}`;
                                  setSelectedItem(selectedItem === allAreasKey ? null : allAreasKey);
                                }}
                              >
                                Applied Areas
                                <FontAwesomeIcon
                                  icon={selectedItem === `all-areas-${index}` ? faAngleUp : faAngleDown}
                                  className="ml-2 w-3 h-3"
                                />
                              </button>
                              
                              {/* Show all areas when expanded */}
                              {selectedItem === `all-areas-${index}` && (
                                <div className="mt-1 pl-2 border-l-2 border-gray-200">
                                  {item.applied_areas.map((area, areaIdx) => (
                                    <div key={areaIdx} className="mb-1">
                                      <p className="text-xs text-gray-500">
                                        • {area.area_name || area.room_name}
                                      </p>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          );
                        }
                        
                        return result;
                      })()}
                    </div>
                  )}
                </>
              )}
            </div>
            
            <div className="flex flex-col items-end">
              <div className="flex items-center mb-1">
                <span className="text-xs text-[#524D4D]">{item.quantity} {item.UOM}</span>
              </div>
              
              <div className="flex items-center mb-1">
                <span className="text-xs text-[#524D4D]">₹{item.selling_price.toLocaleString()}/ {item.UOM}</span>
              </div>
            </div>
          </div>
        )}
        
        {/* Only show this total line for Tiles, not for Windows */}
        {data?.product_category_id?.product_category_name?.toLowerCase() !== 'windows' && (
          <div className='mt-1.5 flex justify-end border-b border-gray-100 pb-1'>
            <div className="flex items-center font-semibold">
              <span className="text-sm">₹{(item.total || (item.selling_price * item.quantity)).toLocaleString()}</span>
            </div>
          </div>
        )}
        
        {/* Add a border-bottom for Windows items */}
        {data?.product_category_id?.product_category_name?.toLowerCase() === 'windows' && (
          <div className='border-b border-gray-100 mt-1 pb-1'></div>
        )}
      </div>
    ))}
    
    {/* Hardware Summary Section - Only for Doors */}
    {data?.product_category_id?.product_category_name?.toLowerCase() === 'doors' && (
  (() => {
    // Extract all hardware items from all door items
    const allHardwareItems = [];
    
    // Collect all hardware items from all doors
    data?.items?.forEach(item => {
      if (item.product_addons && Array.isArray(item.product_addons)) {
        const hardwareAddons = item.product_addons.filter(
          addon => addon && addon.product_addon_type?.toLowerCase() === 'hardware'
        );
        
        if (hardwareAddons.length > 0) {
          allHardwareItems.push(...hardwareAddons);
        }
      }
    });
    
    // If no hardware items found, don't render this section
    if (allHardwareItems.length === 0) {
      return null;
    }
    
    // Group hardware items by item_id to combine quantities
    const hardwareMap = {};
    
    allHardwareItems.forEach(hardware => {
      const key = hardware.item_id;
      if (!hardwareMap[key]) {
        hardwareMap[key] = {
          ...hardware,
          totalQuantity: parseInt(hardware.quantity) || 1
        };
      } else {
        hardwareMap[key].totalQuantity += parseInt(hardware.quantity) || 1;
      }
    });
    
    // Convert map to array for rendering
    const uniqueHardwareItems = Object.values(hardwareMap);
    
    // Calculate total hardware cost
    const totalHardwareCost = uniqueHardwareItems.reduce((total, item) => {
      const itemPrice = parseFloat(item.selling_price) || 0;
      return total + (itemPrice * item.totalQuantity);
    }, 0);
    
    return (
   <div className="mt-4 mb-4">
  {/* Hardware section header with clean styling */}
  <div className="flex justify-between items-center py-2 border-t border-b border-gray-200 mb-2">
    <div className="flex items-center">
      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-gray-500 mr-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
      </svg>
      <h3 className="text-md font-medium text-gray-700">Door Hardware</h3>
    </div>
    <p className="text-sm font-medium text-[#14A311]">₹{totalHardwareCost.toLocaleString()}</p>
  </div>
  
  {/* Hardware items list with clean layout */}
  <div className="space-y-2">
    {uniqueHardwareItems.map((hardware, idx) => (
      <div key={idx} className="flex justify-between items-center py-2 border-b border-gray-100 last:border-b-0">
        {/* Left side - Hardware info with full name */}
        <div className="flex items-center flex-1 min-w-0 pr-2">
          {hardware.item_image ? (
            <div className="w-10 h-10 bg-gray-50 rounded-md border border-gray-200 mr-3 flex-shrink-0 flex items-center justify-center overflow-hidden">
              <img
                src={process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES + hardware.item_image}
                alt={hardware.item_name}
                className="max-h-8 max-w-8 object-contain"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "https://via.placeholder.com/40?text=H";
                }}
              />
            </div>
          ) : (
            <div className="w-10 h-10 bg-gray-100 rounded-md mr-3 flex-shrink-0 flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
              </svg>
            </div>
          )}
          
          <div className="flex-1 min-w-0">
            {/* Full hardware name without truncation */}
            <p className="text-sm font-medium text-gray-800 break-words pr-2">
              {hardware.item_name}
            </p>
            <p className="text-xs text-gray-500">
              {hardware.item_group_name || hardware.vendor_name || "Hardware"}
            </p>
          </div>
        </div>
        
        {/* Right side - Simple quantity and price display */}
        <div className="flex flex-col items-end text-right">
          <p className="text-sm text-gray-600">{hardware.totalQuantity} × ₹{parseFloat(hardware.selling_price).toLocaleString()}</p>
          <p className="text-sm font-semibold text-gray-800">
            ₹{(hardware.totalQuantity * parseFloat(hardware.selling_price)).toLocaleString()}
          </p>
        </div>
      </div>
    ))}
  </div>
</div>


    );
  })()
)}


    {/* Summary totals and terms section */}
    <div className="mt-3 pt-2 border-t border-gray-200">
      {/* Subtotal row */}
      <div className="flex justify-between items-center py-1">
        <p className="text-md text-gray-600">Subtotal:</p>
        <p className="text-md">₹{data.subtotal?.toLocaleString()}</p>
      </div>
      
      {buildCoinsEnabled && data.buildCoinsDiscount > 0 && (
        <div className="flex justify-between items-center py-1 text-[#C20C0C]">
          <p className="text-sm flex items-center">
            BuildCoins Discount
            <img src={BuildCoin} alt="BuildCoin" className="ml-1 h-4 w-4 inline-block" />
          </p>
          <p className="text-sm">-₹{data.buildCoinsDiscount?.toLocaleString()}</p>
        </div>
      )}
      
      {walletCoinsApplied && (
        <div className="flex justify-between items-center py-1 text-[#C20C0C]">
          <p className="text-sm flex items-center">
            Wallet Balance
          </p>
          <p className="text-sm">-₹8,000</p>
        </div>
      )}
      
      {/* GST row */}
      <div className="flex justify-between items-center py-1">
        <p className="text-md text-gray-600">GST (18%):</p>
        <p className="text-md">₹{data.tax_amount?.toLocaleString()}</p>
      </div>
      
      {/* Transport charges row */}
      <div className="flex justify-between items-center py-1">
        <p className="text-md text-gray-600">Transport (approx):</p>
        <p className="text-md">₹{(data?.transport_charges || 0).toLocaleString()}</p>
      </div>
      
      <div className="flex justify-end mt-2">
        <div className="border-t border-gray-300 w-1/3"></div>
      </div>
      
      {/* Total row with bold styling */}
      <div className="flex justify-between items-center font-bold mt-1">
        <p className='flex flex-col text-lg leading-none'>
          Total Price
          <span>
            <button
              className="text-blue-600 text-[12px] font-medium hover:underline focus:outline-none mt-1"
              onClick={() => {/* Handle showing terms and conditions */}}
            >
              Terms & Conditions <FontAwesomeIcon icon={faInfoCircle} className="w-3 h-3" />
            </button>
          </span>
        </p>
        <p className="text-lg">₹{Number(data.total).toLocaleString('en-IN')}</p>
      </div>
    </div>
  </div>
</div>

</div>
  

{/* Build COins Div starts */}


<div className="mt-2 rounded-lg shadow-sm border border-gray-200 overflow-hidden mx-4">
  {/* Header section */}
  <div className="p-4">
    <h3 className="text-xl font-semibold text-gray-800">BuildCoins</h3>
    
    {/* Eligibility message and apply button */}
    <div className="mt-3 flex justify-between items-center">
      <p className="text-sm text-gray-700">
        {buildCoinsEnabled ? (
          <span className="text-green-600">
            <span className="font-regular">applied {
              (data?.buildcoins?.data?.rewards?.find(bc => bc.immediate)?.reserved_coins ?? 0)
        }</span>
            <img src={BuildCoin} alt="BuildCoin" className="mx-1 h-5 w-5 inline-block" />
            BuildCoins to this order.
          </span>
        ) : (
          <span>
            You are eligible to apply <span className="font-bold">
            {data?.buildcoins?.data?.rewards?.find(bc => bc.immediate)?.reserved_coins ?? 0}
            </span>
            <img src={BuildCoin} alt="BuildCoin" className="mx-1 h-5 w-5 inline-block" />
            BuildCoins (₹<span className="font-bold">    
              {data?.buildcoins?.data?.rewards?.find(bc => bc.immediate)?.reserved_coins ?? 0}
            </span>) on this order.
          </span>
        )}
      </p>
      <div className="flex items-center mt-3">
{/*        
        <button 
          className={`rounded-md px-2 py-1 text-xs flex items-center justify-start border ${
            buildCoinsEnabled 
              ? 'border-gray-300 text-gray-400 bg-gray-100' 
              : 'border-[#C20C0C] text-[#C20C0C] hover:bg-[#FFF0F0]'
          }`}
          onClick={!buildCoinsEnabled ? toggleBuildCoins : undefined}
          disabled={buildCoinsEnabled}
        >
          {buildCoinsEnabled ? 'Applied' : 'Apply'}
        </button>
        
        {buildCoinsEnabled && (
          <button 
            className="ml-2 text-xs text-[#C20C0C] border-b border-dotted border-[#C20C0C]"
            onClick={toggleBuildCoins}
          >
            Remove
          </button>
        )} */}
        <button 
  className={`rounded-md px-2 py-1 text-xs flex items-center justify-start border ${
    buildCoinsEnabled 
      ? 'border-gray-300 text-gray-400 bg-gray-100' 
      : 'border-[#C20C0C] text-[#C20C0C] hover:bg-[#FFF0F0]'
  }`}
  onClick={!buildCoinsEnabled ? () => applyBuildcoinsForOrder(data?.buildcoins?.find(bc => bc.immediate),"promise") : undefined}
  disabled={buildCoinsEnabled}
>
  {buildCoinsEnabled ? 'Applied' : 'Apply'}
</button>

{buildCoinsEnabled && (
  <button 
    className="ml-2 text-xs text-[#C20C0C] border-b border-dotted border-[#C20C0C]"
    onClick={() => removeBuildcoinsForOrder(data?.buildcoins?.find(bc => bc.immediate),"promise")}
  >
    Remove
  </button>
)}

      </div>
    </div>
  </div>
  
  {/* Red background section with wallet info */}
  <div className="bg-red-50 p-2">
    <div className="flex justify-between items-start">
      {/* Left side - Wallet balance */}
      <div className="w-1/2 pr-2">
        <div className="flex items-center mb-1 ml-4">
          <h4 className="text-sm font-medium text-gray-700 mr-0.5">Wallet Balance</h4>
          <img src={Walleticon} alt="Wallet" className="h-6 w-8" />
        </div>
        <p className="text-lg text-gray-600 text-center">
          <span className="font-bold text-red-600">{walletBalance || 0}</span>
          <p className="text-center text-xs">BuildCoins</p>
        </p>
      </div>
      
      {/* Right side - Apply from wallet */}
      <div className="w-1/2 pl-3 border-l border-gray-200">
        <p className="text-xs text-gray-700 mb-2">
          {walletCoinsApplied ? (
            <span className="text-green-500 font-medium">
              <span className="font-regular"> applied {walletCoinsApplicable} </span>
              <img src={BuildCoin} alt="BuildCoin" className="mx-0.1 h-3.5 w-3.5 inline-block" />
              BuildCoins from your wallet.
            </span>
          ) : (
            <>
              Apply another
              <span className="inline-flex items-center font-semibold">
                <span className="font-bold mx-1 text-md">{walletCoinsApplicable}</span>
                <img src={BuildCoin} alt="BuildCoin" className="mx-0.1 h-3.5 w-3.5 inline-block" />
              </span>
              <span className="block font-medium">BuildCoins (₹<span className="font-bold">{walletCoinsApplicable}</span>) from your wallet.</span>
            </>
          )}
        </p>
        <div className="flex items-center">
{/*           <button
            className={`rounded-md px-2 py-0.5 text-xs flex items-center justify-center border ${
              walletCoinsApplied
                ? 'border-gray-300 text-gray-400 bg-gray-100'
                : 'border-[#C20C0C] text-black'
            }`}
            onClick={!walletCoinsApplied ? toggleWalletCoins : undefined}
            disabled={walletCoinsApplied}
          >
            {walletCoinsApplied ? 'Applied' : 'Apply'}
          </button>
          
          {walletCoinsApplied && (
            <button 
              className="ml-2 text-xs text-[#C20C0C] border-b border-dotted border-[#C20C0C]"
              onClick={toggleWalletCoins}
            >
              Remove
            </button>
          )} */}


<button 
  className={`rounded-md px-2 py-1 text-xs flex items-center justify-start border ${
    walletCoinsApplied 
      ? 'border-gray-300 text-gray-400 bg-gray-100' 
      : 'border-[#C20C0C] text-[#C20C0C] hover:bg-[#FFF0F0]'
  }`}
  onClick={!walletCoinsApplied ? () => /* applyBuildcoinsForOrder(coinLedger,"wallet") */applyBuildCoinsFromWallet(coinLedger,data?._id) : undefined}
  disabled={walletCoinsApplied}
>
  {walletCoinsApplied ? 'Applied' : 'Apply'}
</button>

{walletCoinsApplied && (
  <button 
    className="ml-2 text-xs text-[#C20C0C] border-b border-dotted border-[#C20C0C]"
    onClick={() => removeBuildcoinsForOrder(coinLedger,"wallet")}
  >
    Remove
  </button>
)}
        </div>
      </div>
    </div>
  </div>

  {/* Earn more BuildCoins section */}
  <div className="p-4">
    <h4 className="text-md font-medium text-gray-800 mb-3">Earn More BuildCoins</h4>
    
    <div className="flex items-start mb-2">
      <img src={Sparkle} alt="Sparkle" className="h-9 w-9 mt-0.5 mr-0.5 flex-shrink-0" />
      <p className="text-sm text-gray-700">
        <span className="font-bold">Place this order</span> to get extra 
        <span className="inline-flex items-center font-bold ml-2">
        {data?.buildcoins?.data?.rewards?.find(bc => bc.immediate === false)?.reserved_coins ?? 0}
        <img src={BuildCoin} alt="BuildCoin" className="mx-1 h-5 w-5 inline-block" />
        </span>
        BuildCoins.
      </p>
    </div>
    
    <div className="flex items-start">
      <FontAwesomeIcon icon={faCircleInfo} className="h-4 w-4 mt-1 mr-3 ml-2 text-red-500 flex-shrink-0" />
      <p className="text-sm text-gray-600">
        BuildCoins will be credited to your wallet after order completion.
      </p>
    </div>
  </div>
</div>


{/* Ready to Place Order section */}
<div className="border mt-4 bg-white rounded-lg shadow-md mx-4">
  <div className="flex items-center justify-between">
    <div className="flex flex-col">
      <h3 className="text-md font-semibold text-gray-800 ml-4 mt-1">Ready to Place Order?</h3>
      <button 
  className="mt-4 w-full border border-red-500 hover:bg-[#A00A0A] text-red-500 font-semibold py-2 px-3 rounded-md transition duration-200 flex items-center justify-center ml-4 mb-4"
  onClick={handlePlaceOrder}
>
  <span>Click Here</span>
  <FontAwesomeIcon icon={faArrowRight} className="ml-4 w-4 h-4" />
</button>

    </div>
    <div>
      <img src={Box} alt="Box" className="h-18 w-18" />
    </div>
  </div>
</div>

{/* Brickbucket Center Card with highlighted message at top */}
<div className="mt-2 rounded-md overflow-hidden mx-4 ">
  {/* Title with background color only for the message - removed border-b */}
  <div className="bg-red-50 p-4">
  <h2 className="text-md font-semibold text-gray-500 leading-tight">
  {data?.product_category_id?.product_category_name?.toLowerCase() === 'windows'
    ? (
        <>
          You can visit our <span className="font-bold">Brickbucket Center</span> to view the window profiles.
        </>
      )
    : (
        <>
          You can visit our <span className="font-bold">Brickbucket Center</span> to view the selected tile designs.
        </>
      )
  }
</h2>
  </div>
 
  {/* Rest of the card with normal background */}
  <div className="p-3 border-l border-r border-b border-gray-200 ">    {/* Center info with better alignment */}
    <div className='flex items-center justify-between mb-1'>
      <div className="flex-1">
        <p className='text-lg font-semibold text-gray-800 mb-2'>Brickbucket Center</p>
        <p className="text-sm text-gray-600 flex items-center">
          <FontAwesomeIcon icon={faClock} className="mr-2 text-[#C20C0C] w-4 h-4" />
          <span>10 AM - 8 PM</span>
        </p>
      </div>
      <div className="flex-shrink-0 ml-4">
        <img
          src={Store}
          alt="Brickbucket Store"
          className="h-16 w-auto object-contain"
        />
      </div>
    </div>
    
    {/* Address with improved alignment */}
    <div className='flex items-start mb-4'>
  <FontAwesomeIcon
    icon={faLocationPin}
    className="mt-1 mr-3 text-[#C20C0C] w-4 h-4 flex-shrink-0"
  />
  <p className="text-sm text-gray-600">
    1st Floor, Swarna Grand, NH 16 Service Rd, Nagarjuna Nagar, Vijayawada
  </p>
</div>
    
{/* Button with improved styling */}
<div className="flex justify-center">
  <button 
    className='w-full rounded-md px-2 py-2 flex items-center justify-center border border-[#F30F0F] text-[#F30F0F] font-medium transition-colors mb-2'
    onClick={() => {
      // Encode the address for the URL
      const address = encodeURIComponent("1st Floor, Swarna Grand, NH 16 Service Rd, Nagarjuna Nagar, Vijayawada");
      // Open Google Maps in a new tab
      window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, '_blank');
    }}
  >
    <span>View Location</span>
    <FontAwesomeIcon icon={faAngleRight} className="ml-2 text-red-500 w-4 h-4" />
  </button>
</div>

  </div>
</div>



<div className="mt-5 bg-[#F3FFFE] rounded-lg  shadow-sm border border-[#E0F5F3] mx-4 p-4 mb-10">
  {/* Heading */}
  <h3 className="text-lg font-semibold text-gray-800">Want to talk to us?</h3>
  
  {/* Paragraph in its own container */}
  <p className="mt-2 text-sm text-gray-600">
    Explore more options by talking to our customer support team.
  </p>
  
  {/* Separate div for the button, aligned to the right */}
  <div className="mt-3 flex justify-end">
    <button
      className="border border-red-500 text-red-500 hover:bg-[#FFF0F0] font-medium py-2 px-4 rounded-md transition duration-200 flex items-center justify-center"
      onClick={() => setShowCallbackPopup(true)}
    >
      <FontAwesomeIcon icon={faPhoneFlip} className="mr-2 w-4 h-4 rotate-90" />
      <span>Request Callback</span>
    </button>
  </div>
</div>




{/* Order Received Popup */}
{showOrderReceivedPopup && (
  <>
    {/* Overlay */}
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
      onClick={() => setShowOrderReceivedPopup(false)}
    ></div>
    
    {/* Popup from bottom */}
    <div className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-lg z-50 transform transition-transform duration-300 ease-out ${showOrderReceivedPopup ? 'translate-y-0' : 'translate-y-full'}`}>
      {/* Header with success color */}
      <div className="flex justify-between items-center p-5  rounded-t-2xl">
        <h3 className="text-lg font-semibold ">Order Received!</h3>
        <button
          onClick={() => setShowOrderReceivedPopup(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          <FontAwesomeIcon icon={faTimesCircle} className="w-5 h-5" />
        </button>
      </div>
      
      {/* Content */}
      <div className="p-5">
        <div className="flex flex-row items-center justify-center mb-4">
          {/* Success checkmark icon */}
          <div>
          <h4 className="text-xl font-bold text-[#C20C0C] mb-2">Congratulations!</h4>
          <p className="text-left text-gray-600 mb-3">
          We have received your order request.
          </p>
          </div>
          <div className="w-28 h-full flex items-center justify-end mb-3">
          <img src={Check} alt="Box" className="h-20 w-20" />
          </div>
        </div>
        <p className="text-sm text-gray-500 mb-4">
          Our Brickbucket team will contact you and visit the project to confirm the order.
          </p>
        <button
          onClick={() => {
            setShowOrderReceivedPopup(false);
            // You might want to navigate to an order confirmation page
            // navigate('/order-confirmation', { state: { orderId: data?.quotation_number } });
          }}
          className="w-full bg-[#C20C0C] opacity-[71%] text-white font-medium py-3 px-4 rounded-md hover:bg-[#A00A0A] transition duration-200"
        >
          OK, Got it
        </button>
      </div>
    </div>
  </>
)}
{/* Order Received Popup ends */}

{/* BuildCoins Info Popup */}
  {showBuildCoinsInfo && (
  <>
    {/* Overlay */}
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
      onClick={() => setShowBuildCoinsInfo(false)}
    ></div>
    
    {/* Popup from bottom - split into two halves */}
    <div className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-lg z-50 transform transition-transform duration-300 ease-out ${showBuildCoinsInfo ? 'translate-y-0' : 'translate-y-full'}`}>
      {/* First half with #A04545 background */}
      <div className="bg-[#A04545] text-white rounded-t-2xl p-5">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            <img src={BuildCoin} alt="BuildCoin" className="h-8 w-8 mr-2" />
            <h3 className="text-[#F2BB4D] text-xl font-semibold">BuildCoins</h3>
          </div>
          <button
            onClick={() => setShowBuildCoinsInfo(false)}
            className="text-white hover:text-gray-200"
          >
            <FontAwesomeIcon icon={faTimesCircle} className="w-5 h-5" />
          </button>
        </div>
        
        <div className="mt-4 flex justify-between items-center">
          {/* Left side - Balance information */}
          <div>
            <p className="text-xl">Use <span className='font-semibold text-[#F2BB4D]'>BuildCoins</span></p>
            <div className="flex items-center">
              <span className="text-[10px] ">& get discounts on orders!</span>
            </div>
            <p className="text-sm mt-2 ">1 buildcoin equals ₹1</p>
          </div>
          
          {/* Right side - Wallet image */}
          <div className="flex items-center justify-center">
            <img src={Wallet} alt="Wallet" className="h-26 w-26" />
          </div>
        </div>
        <div className='mb-2 text-xs flex justify-end'>
        *Terms and Conditions apply
        </div>
      </div>
      
      {/* Second half with white background and rounded top */}
      <div className="bg-white p-5 rounded-t-3xl -mt-6">
        <h4 className="text-xl font-bold text-[#A04545] mb-2">WHAT ARE  
         <span className='text-[#F2BB4D]'> BUILDCOINS?</span>
          </h4>
        <p className="pb-3 pr-3  text-sm font-semibold mb-3">
        When you use Brickbucket to purchase building materials, you are rewarded with BuildCoins that you can redeem on the orders you place.
        </p>
        <div className='p-2 flex flex-col rounded-md bg-[#FFEFEF]'>
          <div className='p-2 flex flex-row justify-center'>
            <img src={BuildCoin} alt="BuildCoin" className="h-7 w-8" />
        <h4 className="text-md font-bold">1 = ₹1</h4>
        </div>
        <li className="text-[12px] font-semibold ">
        Every set of BuildCoins can have an expiry date
        </li>
        <li className="text-[12px] font-semibold  ">BuildCoins are credited in your Brickbucket wallet</li>
        </div>
      </div>
    </div>
  </>
)}
{/* BuildCoins Info Popup ends*/}

{/* Request Callback Popup */}
{showCallbackPopup && (
  <>
    {/* Overlay */}
    <div
      className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
      onClick={() => setShowCallbackPopup(false)}
    ></div>
    
    {/* Popup from bottom */}
    <div className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-lg z-50 transform transition-transform duration-300 ease-out ${showCallbackPopup ? 'translate-y-0' : 'translate-y-full'}`}>
      {/* Header with gray background */}
      <div className="flex justify-between items-center p-5 bg-gray-100 rounded-t-2xl">
        <h3 className="text-lg font-semibold text-gray-800">Details for Callback</h3>
        <button
          onClick={() => setShowCallbackPopup(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          <FontAwesomeIcon icon={faTimesCircle} className="w-5 h-5" />
        </button>
      </div>
      
      {/* Subheading with phone number */}
      <div className="px-5 py-3 border-b border-gray-200">
        <p className="text-sm text-gray-600">We'll call you on +91-97*****725</p>
      </div>
      
      <div className="p-5">
        {/* Tabs for Today and Tomorrow */}
        <div className="flex border-b border-gray-200 mb-4">
          <button 
            className={`py-2 px-4 font-medium text-lg ${selectedTab === 'today' ? 'text-[#C20C0C] border-b-2 border-[#C20C0C]' : 'text-gray-500'}`}
            onClick={() => setSelectedTab('today')}
          >
            Today
          </button>
          <button 
            className={`py-2 px-4 font-medium text-lg ${selectedTab === 'tomorrow' ? 'text-[#C20C0C] border-b-2 border-[#C20C0C]' : 'text-gray-500'}`}
            onClick={() => setSelectedTab('tomorrow')}
          >
            Tomorrow
          </button>
        </div>
        
        {/* Time slots */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          <button 
            className={`py-2 px-3 border rounded-md text-sm font-medium ${selectedTimeSlot === 'now' ? 'bg-[#FFF0F0] border-[#C20C0C] text-[#C20C0C]' : 'border-gray-300 text-gray-700'}`}
            onClick={() => setSelectedTimeSlot('now')}
          >
            Call me now
          </button>
          <button 
            className={`py-2 px-3 border rounded-md text-sm font-medium ${selectedTimeSlot === '4-5pm' ? 'bg-[#FFF0F0] border-[#C20C0C] text-[#C20C0C]' : 'border-gray-300 text-gray-700'}`}
            onClick={() => setSelectedTimeSlot('4-5pm')}
          >
            4-5 PM
          </button>
          <button 
            className={`py-2 px-3 border rounded-md text-sm font-medium ${selectedTimeSlot === '5-6pm' ? 'bg-[#FFF0F0] border-[#C20C0C] text-[#C20C0C]' : 'border-gray-300 text-gray-700'}`}
            onClick={() => setSelectedTimeSlot('5-6pm')}
          >
            5-6 PM
          </button>
          <button 
            className={`py-2 px-3 border rounded-md text-sm font-medium ${selectedTimeSlot === '6-7pm' ? 'bg-[#FFF0F0] border-[#C20C0C] text-[#C20C0C]' : 'border-gray-300 text-gray-700'}`}
            onClick={() => setSelectedTimeSlot('6-7pm')}
          >
            6-7 PM
          </button>
        </div>
        
{/* Description field */}
<div className="mb-6">
  <textarea
    value={callbackDescription}
    onChange={(e) => setCallbackDescription(e.target.value)}
    placeholder="What do you need help with? (optional)"
    rows="3"
    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#C20C0C] focus:border-transparent resize-none"
  ></textarea>
</div>

        
        <button
          onClick={() => {
            // Handle the callback request submission
            const day = selectedTab === 'today' ? 'Today' : 'Tomorrow';
            const time = selectedTimeSlot === 'now' ? 'as soon as possible' : `between ${selectedTimeSlot}`;
            alert(`Callback requested for ${callbackName} ${day} ${time}`);
            setShowCallbackPopup(false);
          }}
          className="w-full bg-[#C20C0C] text-white font-medium py-3 px-4 rounded-md hover:bg-[#A00A0A] transition duration-200"
        >
          Submit 
        </button>
      </div>
    </div>
  </>
)}

{/* Window List Popup */}
 <WindowListPopup 
        isOpen={showWindowListPopup}
        onClose={() => setShowWindowListPopup(false)}
        selectedWindowItem={selectedWindowItem}
      />


</div>
  
  );
}
  

export default Proceed;
